import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import ADNodeSelect from '@pages/schemes/components/Flow/ADNodeSelect';
import { useReactFlow } from 'reactflow';

const ADRoleSelector = ({ node }) => {
    const { t } = useTranslation();
    const { setNodes } = useReactFlow();
    const [role, setRole] = useState(node.data.ad_role);

    const handleUpdateADRole = (e) => {
        const newRole = e.target.value;
        setRole(newRole);

        if (newRole) {
            node.data.ad_role = newRole;
        } else {
            delete node.data.ad_role;
        }

        setNodes((nodes) =>
            nodes.map((nd) => {
                if (nd.id === node.id) {
                    return nd;
                }

                if (nd.type !== 'ad' && nd.type !== 'tech_tour_ad' && nd.type !== 'wec') {
                    return nd;
                }

                // clear all references to node_id when role changed
                for (const field of ['forest_root_id', 'parent_domain_id', 'target_domain_id']) {
                    if (nd.data[field] === node.id) {
                        delete nd.data[field];
                    }
                }

                return nd;
            }),
        );

        // when change role, delete redundant fields
        delete node.data.forest_root_id;
        delete node.data.parent_domain_id;
        delete node.data.target_domain_id;
    };

    return (
        <Box mb={1} sx={{ display: 'flex', gap: 1 }}>
            <FormControl sx={{ width: '45%' }} size="small">
                <InputLabel id="role-select-label">{t('role')}</InputLabel>
                <Select
                    labelId="role-select-label"
                    id="role-select"
                    value={role}
                    label={t('role')}
                    onChange={handleUpdateADRole}
                >
                    <MenuItem value={''} sx={{ fontStyle: 'italic', opacity: 0.7 }}>
                        none
                    </MenuItem>
                    <MenuItem value={'forest'}>forest</MenuItem>
                    <MenuItem value={'tree'}>tree</MenuItem>
                    <MenuItem value={'child'}>child</MenuItem>
                    <MenuItem value={'additional'}>additional</MenuItem>
                </Select>
            </FormControl>
            {role === 'tree' && <ADNodeSelect node={node} field="forest_root_id" />}
            {role === 'child' && <ADNodeSelect node={node} field="parent_domain_id" />}
            {role === 'additional' && <ADNodeSelect node={node} field="target_domain_id" />}
        </Box>
    );
};

export default ADRoleSelector;
